import Vue from "vue";
import Component from "vue-class-component";
import $ from "jquery";
import { ServicesFactoryInstance } from "../../../Controls/ServicesFactory";
import { ParametresInstance } from "../../../Controls/Parameters";
import { SocieteDsnDto } from "../../../../dto/GenApi.iNotPaie.Dto/SocieteDsnDto";
import { OrganismeDto } from "../../../../dto/GenApi.iNotPaie.Dto/OrganismeDto";
import { ParametreDto } from "../../../../dto/GenApi.iNotPaie.Dto/ParametreDto";
import { SocieteReglementsDto } from "../../../../dto/GenApi.iNotPaie.Dto/SocieteReglementsDto";
import { NotificationServiceInstance } from "../../../../shared/services/notification.service";

@Component
export default class ModalAjoutOrganisme extends Vue {
    public isUpdate = false;
    public organisme: OrganismeDto = { Id: 0, TypeDeBase: 0 };
    public societeDsn: SocieteDsnDto = { Id: 0, Organismes: [] };
    public societeReglements: SocieteReglementsDto = { Id: 0, ReglementType: [] };
    public typeOrganisme?: string;

    // Liste des combos
    public listeModesPaiementOrganismes: ParametreDto[] = [];

    public Init(societeDsn: SocieteDsnDto, organisme?: any): void {
        this.societeDsn = societeDsn;
        if (this.societeDsn.Code != undefined) {
            ServicesFactoryInstance.SocieteService.getSocieteReglements(this.societeDsn.Code, (data) => {
                this.societeReglements = data;
                console.warn(data);
            });
        }

        this.initOrganisme(organisme);
        this.initConstantes();
        this.$forceUpdate();
    }

    public initConstantes(): void {
        ServicesFactoryInstance.ParametresService.getListeModesPaiementOrganismes(data => {
            this.listeModesPaiementOrganismes = data;
        });
    }

    public initOrganisme(organisme?: OrganismeDto) {

        if (organisme != undefined) {
            this.organisme = organisme;
            this.isUpdate = true;
        } else {
            if (ParametresInstance.societeCourante != undefined && ParametresInstance.societeCourante.Code != undefined) {
                this.organisme =
                {
                    Id: 0,
                    Type: "R",
                    CodeSociete: ParametresInstance.societeCourante.Code,
                    TypeDeBase: 0
                };
            }
        }

        if (this.organisme.Type == "O") {
            switch (this.organisme.Regime) {
                case "CRPCEN":
                    this.typeOrganisme = "C"
                    break;
                case "URSSAF":
                    this.typeOrganisme = "U"
                    break;
                case "DGFIP":
                    this.typeOrganisme = "D"
                    break;
            }
        }
        else {
            this.typeOrganisme = this.organisme.Type;
        }
    }

    public selectionChanged(): void {
        this.isUpdate = this.typeOrganisme == "U" || this.typeOrganisme == "C" || this.typeOrganisme == "D";
        this.$forceUpdate();
    }

    public annuler(): void {
        $("#modalAjoutUpdateOrganisme").modal("hide");
        this.$emit("refresh");
    }

    public update(): void {
        // URSSAF //CRPCEN //DGFIP
        if (this.typeOrganisme == "U" || this.typeOrganisme == "C" || this.typeOrganisme == "D") {

            this.organisme.Type = "O";
            switch (this.typeOrganisme) {
                case "D":
                    this.organisme.NumeroOrganisme = "FIP";
                    break;
                case "U":
                    this.organisme.NumeroOrganisme = "URS";
                    break;
                case "C":
                    this.organisme.NumeroOrganisme = "CRP";
                    break;
            }

            ServicesFactoryInstance.OrganismeService.updateOrganisme(this.organisme, () => {
                this.annuler();
                NotificationServiceInstance.SendSuccess("La société a été modifiée avec succès.");
                this.$emit("refresh");
            });
        } else {
            this.organisme.Type = this.typeOrganisme;
            if (!this.isUpdate) {
                this.societeDsn.Organismes.push(this.organisme);
            }

            this.societeDsn.Organismes.forEach((orga) => {
                if ((orga.Type == "U" && orga.NumeroOrganisme == "URS") ||
                    (orga.Type == "C" && orga.NumeroOrganisme == "CRP") ||
                    (orga.Type == "D" && orga.NumeroOrganisme == "FIP")) {
                    orga.Type = "O";
                }
            });

            ServicesFactoryInstance.SocieteService.updateSocieteDsn(this.societeDsn, () => {
                this.annuler();
                NotificationServiceInstance.SendSuccess("La société a été modifiée avec succès.");
                this.$emit("refresh");
            });
        }
    }

    public openLink(): any {
        window.open("https://fichierdirect.declaration.urssaf.fr/TablesReference.htm", "_blank");
    }
}



// WEBPACK FOOTER //
// ./src/components/ficheSociete/dsn/modalAjoutUpdateOrganisme/modalAjoutUpdateOrganisme.ts